import * as React from "react";
import {FreeHtml} from "sb-resp-lib";
import {Title} from "../Title";
import {Link} from "../Link";
import {Image} from "../Image";

export class CasinoItem extends React.Component < {
    title : string,
    link : string,
    linkText : string,
    image : string,
    freeHtml : string
}, {} > {

    renderHeadline() {
        return (
            <header className="rj-hamburger-casino-block__casino-item-header">
                <Link
                    href={this.props.link}
                    class="rj-hamburger-casino-block__casino-item-link">
                    {(this.props.title && <Title
                        text={this.props.title}
                        class="rj-hamburger-casino-block__casino-item-title"/>)}
                    {(this.props.linkText && <Title
                        text={this.props.linkText}
                        class="rj-hamburger-casino-block__casino-item-title-link"/>)}
                </Link>
            </header>
        );
    }

    renderImage() {
        return (<Image
            class="rj-hamburger-casino-block__casino-item-image-wrap"
            source={this.props.image}/>);
    }

    renderFreeHtml() {
        return (<FreeHtml html={this.props.freeHtml}/>);
    }

    render() {
        return (
            <div className="rj-hamburger-casino-block__item">
                {(this.props.title || this.props.link || this.props.linkText) && this.renderHeadline()}
                {(this.props.image) && this.renderImage()}
                {(this.props.freeHtml) && this.renderFreeHtml()}
            </div>
        )
    }
}